<template>
    <div v-if="!isGroupParticipant">
        <h2>{{$t('eventRegistration.summary.comments')}}</h2>
        <base-input>
            <textarea v-model="comment" class="form-control" rows="3"></textarea>
        </base-input>
    </div>
</template>

<script>

    import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
    import registrationGroupMixin from "@/mixins/registration/registrationGroupMixin";

    export default {
        name: "Comment",
        mixins: [mainRegistrationMixin, registrationGroupMixin],
        computed: {
            comment: {
                get: function () {
                    return this.registrationData.comment
                },
                set: function (value) {
                    this.setRegistrationProp('comment', value)
                }
            },
        }
    }
</script>

<style scoped>

</style>